import MVPTerms from './MVPTerms';
export default MVPTerms;
